import React from "react"
import styled from "styled-components"

const Container = styled.div`
  width: 300px;
  height: 300px;
  position: relative;
  mix-blend-mode: overlay;
  /* mix-blend-mode: difference; */
  svg {
    width: 100%;
    height: 100%;
    path {
      stroke-dasharray: 242;
      stroke-dashoffset: 242;
      fill: none;
      stroke: rgba(255, 255, 255, 0.9);
      stroke-width: 3.0664;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }
  @keyframes dash {
    to {
      stroke-dashoffset: 0;
    }
  }
  &.start {
    svg {
      path {
        animation: dash 4s linear forwards;
      }
    }
  }
  @media (min-width: 768px) {
    width: 600px;
    height: 600px;
  }
`

const Tiger = ({ start, ...props }) => {
  return (
    <Container {...props} className={start ? `start` : null}>
      <svg x="0px" y="0px" viewBox="0 0 344.5 290.4">
        <g>
          <g>
            <g>
              <path
                className="st0"
                d="M92,21.6c4.1,2.2,20.9-14.1,24.3-15.9c9.9-5.3,23.8-7.1,31.2,3.6"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M156.4,13.5c10.5,4.7,21.3,3.7,31.7,0.3"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M198.4,10.7c8.4-4.9,16.4-8.7,26.5-6.9c8.2,1.5,13,7.9,20.6,10.7"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M259.1,19.6c2.5,11.6,34.7,2.4,40.2,16.7"
              />
            </g>
            <g>
              <path className="st0" d="M297.6,27.4c6,1.7,27.1,3.4,33.4,0.3" />
            </g>
            <g>
              <path
                className="st0"
                d="M338.2,28.5c2.2,6.6,7,10.7,3.7,18.1c-2.6,5.7-13.7,15.1-18.7,19.1"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M318.7,68.4c-3.2,16.6-23.2,8.9-32.4,9.2"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M338.5,34.9c-11.8,0-41.8,19.9-52.5,8.9"
              />
            </g>
            <g>
              <path className="st0" d="M284.6,50.3c-3.3,0.2-6.8-2.2-7.8-5.5" />
            </g>
            <g>
              <path className="st0" d="M274.4,54c-2.2-1.3-4.3-3.4-6.5-4.8" />
            </g>
            <g>
              <path className="st0" d="M288.4,62.9c-1.4,4.7,0.2,7.6,4.8,8.5" />
            </g>
            <g>
              <path
                className="st0"
                d="M129.5,28.8c15-0.4,26.8,10.8,42.3,9c14.8-1.7,27.1-7.6,42.7-7.6c-1.1,0-2.1,0-3.2,0"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M132.5,50.3c5.8-0.5,9.8,5.1,14.6,7.3c7.2,3.2,17.2,4.1,24.9,3.1c14.4-1.9,25.3-19.7,40-16.2"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M140.4,74.2c18,13.1,47.9,12.4,63.1-4.4"
              />
            </g>
            <g>
              <path className="st0" d="M97.8,60.5c3.5,1,34.8,13.3,30.3,21.5" />
            </g>
            <g>
              <path
                className="st0"
                d="M143.1,93.6c9.5,2.4,15,5.6,25.2,5.2c9.8-0.4,19.5-2.5,29.3-2.5"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M208.6,90.5c14.1-12.4,15.1-26.7,35.5-32.4"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M278.8,84.4c-9.8,4-21.1-7.3-30.9-7.9c-10.4-0.6-17.9,5.4-24,13.3"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M265.9,85.1c2.6,7.2-7.4,18.7-14,20.6c-11,3.1-20.3-6.2-27.3-12.8"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M305.1,86.8c7,3.9,15.9,8.2,19.8,15.6c-8,0-11.2-0.5-4.9,8.2c-2.2-0.5-4.5-1.1-6.7-1.6
				c0.6,3.9,7.2,13.6,10.1,16.3c-7.5-1.1-4.1,0.8,0.4,6.5c-8.6-5.4,0.2,7.1-0.3,11.8c0.6-3.5,0-3.4-1.7,0.5"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M322.5,148.5c2.3,2.6,4,5.6,5.1,8.9c-1.7,0.1-3.3-0.3-4.7-1c1.1,2.2,1.8,4.6,2,7.1c-5.7-0.1-3.4,1.6-2.7,7.2
				c-8.1-1.3-2.1,14-1.4,17c-3.5-3.5-5.6,0.9-8.4-2"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M121.3,90.5c-8.4,1-13.4-16-24.9-15.1c-2.7,0.2-25.9,7.2-26.6,9.3"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M82.1,84.7c3.5,9.7,1.5,16.3,14,19.6c8.3,2.2,18.6-0.6,23.5-8.4"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M82.4,24.7c-11.7,3.8-35.7-1.2-35.1,18.8"
              />
            </g>
            <g>
              <path className="st0" d="M48,31.2c-6,2.4-4.9,1.3-9.2,6.1" />
            </g>
            <g>
              <path
                className="st0"
                d="M37.1,31.2c-10.1,3-27.4-3.5-33.6,7C-2.8,49,7.3,56.6,14.2,61.5c4,2.8,5,2.9,7.9,6.3c2,2.4,3.5,6.9,6.2,9.9
				c4.9,5.3,9.5,8.4,17,8.7c7,0.3,11.5-5.8,16.9-5.8"
              />
            </g>
            <g>
              <path className="st0" d="M69.1,45.9c-3.8,1.5-5.7,0.7-7.2,4.8" />
            </g>
            <g>
              <path className="st0" d="M71.5,51.3c-4.4,1.6-4.1,1.6-8.2,4.1" />
            </g>
            <g>
              <path className="st0" d="M13.2,38c13.1-2,22,27.7,38.9,10.2" />
            </g>
            <g>
              <path className="st0" d="M59.6,62.6c0,6.5,0.2,7.6-2.4,13.6" />
            </g>
            <g>
              <path
                className="st0"
                d="M140.4,119.5c16.9-13.8,55.7-9.5,64.9-3.7c5.6,3.5,16.6,10.3,19.3,16.4"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M229.7,137.6c13.9,17.2,8.5,57.1-20.5,54.9"
              />
            </g>
            <g>
              <path className="st0" d="M194.3,190.1c-6.3,2-16.8-9-21.5-12.3" />
            </g>
            <g>
              <path
                className="st0"
                d="M167.3,178.8c-3.5-0.2-5.9,5-8.4,6.4c-4.5,2.4-9.4,3.2-14.3,4.4c-13.3,3.2-20,2.2-31.5-5.3"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M110.7,175.4c1.8-3.7-1-7.6-0.9-11.2c0.2-6.9,1-10.1,3.9-16.4c5.6-11.9,13-15.8,21.9-24.6"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M146.9,145.8c9.1,0,17.9,1.6,26.7,1.6c7.3,0,16.4-7.2,22.8-0.5"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M199.4,153.3c0.7,8.9-14.3,20.4-21.8,21.8"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M145.8,154.6c5.5,7.3,11,13.5,18.8,19.1"
              />
            </g>
            <g>
              <path className="st0" d="M156.4,155c1.9-8.6-8.6,0.9-1.7,0.3" />
            </g>
            <g>
              <path
                className="st0"
                d="M190.5,156c0.3-1.3,0.6-2.7,0.9-4c-2.4-0.2-3.3,0.9-2.6,3.4"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M219.5,137.2c13.6,4.5,38.8-15,52.9-4.1"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M224.3,150.2c10.4,0.2,45.1-11.7,52.9,0.7"
              />
            </g>
            <g>
              <path className="st0" d="M225.3,161.5c14.6,5,33.2-4.2,46.4,7.5" />
            </g>
            <g>
              <path className="st0" d="M225.6,172c17.7,2.3,30.7,7,41.6,20.8" />
            </g>
            <g>
              <path
                className="st0"
                d="M221.2,181.2c6.1,1.2,24.7,14.2,25.2,21.1"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M131.5,134.9c-11.2,7.5-42.2-13.6-51.1-3.1"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M122.3,149.2c-6.6-0.2-38.8-8.8-41.6,3.4"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M115.5,159.1c-5.2,0.1-52.1-3.9-51.5,7.8"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M117.9,170c-11.8,4.9-18.5-1.2-29.1,8.8c-0.2,0.2-16.7,17.1-16.9,16.7"
              />
            </g>
            <g>
              <path className="st0" d="M115.8,183.3c0.2,0.1,0.5,0.2,0.7,0.3" />
            </g>
            <g>
              <path
                className="st0"
                d="M120.6,180.2c-6.3,2.6-10.2,0.7-15.9,5.3c-4.4,3.6-8.1,10.4-11.8,14.9"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M37.1,97.3c-7.7,1.4-13.9,7.3-15.2,12.9c0.4-1.9,3,7.1,3,6.8c0.1,1.4-7.3,11.8-1.4,10.3
				c-0.4-1.1-0.7-2.3-1.1-3.4"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M25.1,134.2c-1.2,4.2-5.1,6.4-5.8,10.9c-0.3,1.9,3.8,1.3,3.5,4.8c-1.3,12.9-4.2,11.2,7.1,20.4
				c-4.8,1.2-5.7,10-5.7,13.9c9.1,1,8.2,1.8,6.8,11.4"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M285.7,113c3.9,6.8,25.9,37.3,16.7,45.4"
              />
            </g>
            <g>
              <path className="st0" d="M281.2,162.5c0,14,4.6,42.2-10.6,50.8" />
            </g>
            <g>
              <path
                className="st0"
                d="M77.6,109.3c2.4,6.5,17.6,15.8,24.2,12.3"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M236.9,120.5c11.4,3.6,26.4,2.2,35.8-5.5"
              />
            </g>
            <g>
              <path className="st0" d="M250.9,64.6c5.6,2.5,10.4-0.2,16,4.1" />
            </g>
            <g>
              <path className="st0" d="M91.6,66.7C86.7,68.5,78,66,75.9,73.1" />
            </g>
            <g>
              <path
                className="st0"
                d="M58.6,105.9c-1.4,4.8-6,7.5-8.1,11.8c-2.7,5.5-2.6,12.5-3.3,18.5c-1.8,14.2-2.5,28.3-2.5,42.6"
              />
            </g>
            <g>
              <path className="st0" d="M64.3,179.2c4,13.6-1.5,22.4,7.5,35.5" />
            </g>
            <g>
              <path
                className="st0"
                d="M145,195.7c0.8-0.8,5.9,0.2,6.8,0c10.5-1.7,22.8,0,33.5,0c3,0,11.2-1.3,13.1,0.6c3.2,3,1.5,20.7,1.8,25.5
				c8.2-5,11.5-17.7,14-26.1c-27.6,0-55.2,0-82.9,0c0.8,2.5,11,27.9,12.6,25.8c2.8-3.5,0.2-15.1,0.1-19.3"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M189.3,203.1c0.8,3.1,2.2,5.8,4.4,8.1c1.2-2.6,2.1-5.3,2.6-8.1"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M115.5,226.4c3.2,9.5-2.7,18.6,1.6,28.2c4.2,9.5,6.4,14.8,8.6,25.4"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M130.2,281.3c11.6-5.3,3.6-1.8,14,4.5c0.5-2.3,0.6-4.6,0.3-6.9c4.7-0.8,5,7.2,8,8.6c5.8,2.9,2.7,0.1,7.5-1
				c1.6-0.4,2.1-4.7,4.3-4.9c1.8-0.2,3.2,3.8,3.8,3.7c0.9-0.1,2.2,3,4.5,2.6c2.5-0.5,2.7-5.6,4.7-6.4c7.6-3,1.1,0.6,6.5,2.3
				c1.2,0.4,2.7,2.8,4.5,3.3c2.2,0.6,2-2.5,3.5-2.4c2.7,0.1,9.8,0.9,12.9,0.5c6.3-0.8,1.8-1.7,6.8-6.6"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M233.1,222.6c2.3,5.3-1.7,23.7-3.4,28.4c-3.6,9.9-5.7,19-8.5,29.6"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M125.7,224c4.7,14.4-0.5,26.1,20.3,23.9c15-1.6,20.4-8.9,35.9-2.7c11.6,4.6,22.3,11.1,32.2-0.4
				c3.2-3.7,10.7-20.3,5-24.2"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M133.6,220.6c5.2,14.5,9.3,16.1,25,13.5c6.1-1,11.2-3.5,17.7-2.8c3.3,0.4,11.6,4.3,11.8,4.3"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M193.6,236.6c13.7,5.1,18.2-5.8,20.1-16.4"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M99.8,88.3c1-0.1,2.1-0.1,3.1,0.2c0,0.6,0,1.1-0.1,1.7c-0.7,0.3-1.4,0.5-2.2,0.5c-0.7-0.1-1.5-0.6-1.5-1.4"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M242.7,88.8c-0.2,0.7-0.3,1.6,0.1,2.2c0.4,0.7,1.4,1,2,0.4c0.6-1,0-2.5-1.1-2.8"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M178.6,203.3c0.8,3.1,2.2,5.8,4.4,8.1c1.2-2.6,2.1-5.3,2.6-8.1"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M168.2,203.1c0.8,3.1,2.2,5.8,4.4,8.1c1.2-2.6,2.1-5.3,2.6-8.1"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M148.2,202.4c0.8,3.1,2.2,5.8,4.4,8.1c1.2-2.6,2.1-5.3,2.6-8.1"
              />
            </g>
            <g>
              <path
                className="st0"
                d="M158.4,202.4c0.8,3.1,2.2,5.8,4.4,8.1c1.2-2.6,2.1-5.3,2.6-8.1"
              />
            </g>
          </g>
        </g>
      </svg>
    </Container>
  )
}

export default Tiger
